/* Sustainable Rice Farming — editorial interactions */
(function () {
  'use strict';

  /* ── Reading progress bar ─────────────────────────────────── */
  function initProgressBar() {
    var bar = document.createElement('div');
    bar.className = 'srf-progress-bar';
    document.body.appendChild(bar);

    function update() {
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var pct = docHeight > 0 ? Math.min(100, (scrollTop / docHeight) * 100) : 0;
      bar.style.width = pct + '%';
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ── Stat counter animation ───────────────────────────────── */
  function animateCounter(el, target, suffix, duration) {
    var start = null;
    var from = 0;
    var isFloat = String(target).indexOf('.') !== -1;

    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      // Ease out cubic
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = from + (target - from) * eased;
      el.textContent = (isFloat ? current.toFixed(1) : Math.round(current)) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initCounters() {
    var statsSection = document.querySelector('.ag-imported-stats--detail');
    if (!statsSection) return;

    var counters = statsSection.querySelectorAll('.ag-imported-stat__value');
    if (!counters.length) return;

    var triggered = false;

    function trigger() {
      if (triggered) return;
      var rect = statsSection.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.85) {
        triggered = true;
        counters.forEach(function (el) {
          var raw = el.textContent.trim();
          // Extract numeric value and suffix (e.g. "30%", "2×", "40+")
          var match = raw.match(/^([0-9]+\.?[0-9]*)(.*)$/);
          if (!match) return;
          var num = parseFloat(match[1]);
          var suffix = match[2] || '';
          el.textContent = '0' + suffix;
          animateCounter(el, num, suffix, 1800);
        });
      }
    }

    window.addEventListener('scroll', trigger, { passive: true });
    trigger();
  }

  /* ── Scroll reveal ────────────────────────────────────────── */
  function initScrollReveal() {
    var els = document.querySelectorAll('.srf-reveal');
    if (!els.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('srf-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

      els.forEach(function (el) { io.observe(el); });
    } else {
      // Fallback: show all
      els.forEach(function (el) { el.classList.add('srf-visible'); });
    }
  }

  /* ── Label special elements for CSS targeting ────────────── */
  function labelSpecialElements() {
    var shell = document.querySelector('.ag-imported-article-shell');
    if (!shell) return;

    // Meta paragraph: contains " | " (e.g. "Category | Author | 12 min read")
    var paras = shell.querySelectorAll(':scope > p');
    paras.forEach(function(p) {
      if (p.textContent.indexOf(' | ') !== -1) {
        p.classList.add('srf-meta');
      }
    });

    // Sources / References h2 and the ul that follows it
    var headings = shell.querySelectorAll(':scope > h2');
    headings.forEach(function(h2) {
      var text = h2.textContent.toLowerCase();
      if (text.indexOf('source') !== -1 || text.indexOf('reference') !== -1) {
        h2.classList.add('srf-sources');
        var next = h2.nextElementSibling;
        while (next && next.tagName === 'UL') {
          next.classList.add('srf-sources');
          next = next.nextElementSibling;
        }
      }
    });

    // Inject a pull quote after the 4th paragraph
    var allParas = Array.from(shell.querySelectorAll(':scope > p:not(.srf-meta)'));
    if (allParas.length >= 4 && !shell.querySelector('.srf-pull-quote')) {
      var pullText = 'Every healthy harvest represents years of stewardship, careful observation, and respect for the living systems beneath the soil.';
      var cite = 'Agriko Organic Farm — Regenerative Agriculture';
      var block = document.createElement('div');
      block.className = 'srf-pull-quote';
      block.innerHTML = '<p>' + pullText + '</p><cite>' + cite + '</cite>';
      var insertAfter = allParas[3];
      insertAfter.parentNode.insertBefore(block, insertAfter.nextSibling);
    }

    // Label intro paragraph (first non-meta body paragraph)
    var introP = null;
    paras.forEach(function(p) {
      if (!p.classList.contains('srf-meta') && introP === null) {
        introP = p;
      }
    });
    if (introP) introP.classList.add('srf-intro');

    // Label first h2 as opening chapter head (no border-top, larger)
    if (headings.length > 0) headings[0].classList.add('srf-intro-head');

    // Label first paragraph after each h2 as section deck
    headings.forEach(function(h2) {
      var next = h2.nextElementSibling;
      while (next) {
        if (next.tagName === 'P' && !next.classList.contains('srf-meta')) {
          next.classList.add('srf-section-deck');
          break;
        }
        if (next.tagName === 'H2' || next.tagName === 'H3' ||
            next.classList.contains('srf-section-divider') ||
            next.classList.contains('srf-pillar-grid')) {
          break;
        }
        next = next.nextElementSibling;
      }
    });

    // Inject ornamental dividers before h2s (skip first h2, skip sources)
    headings.forEach(function(h2, i) {
      if (i === 0) return;
      if (h2.classList.contains('srf-sources')) return;
      var divEl = document.createElement('div');
      divEl.className = 'srf-section-divider';
      divEl.innerHTML = '<span class="srf-div-icon">✶</span>';
      h2.parentNode.insertBefore(divEl, h2);
    });
  }

  /* ── Wrap h3 + following content (p, ul) into field notes ── */
  function wrapFieldNotes() {
    var shell = document.querySelector('.ag-imported-article-shell');
    if (!shell) return;

    var changed = true;
    while (changed) {
      changed = false;
      var children = Array.from(shell.children);
      for (var i = 0; i < children.length; i++) {
        var el = children[i];
        if (el.tagName !== 'H3') continue;

        // Collect following p/ul/ol until next h3, h2, divider, grid, or special element
        var content = [];
        var j = i + 1;
        while (j < children.length) {
          var nx = children[j];
          var tag = nx.tagName;
          if ((tag === 'P' || tag === 'UL' || tag === 'OL') &&
              !nx.classList.contains('srf-meta')) {
            content.push(nx);
            j++;
          } else {
            break;
          }
        }

        var hasUl = content.some(function(c) { return c.tagName === 'UL' || c.tagName === 'OL'; });
        if (!hasUl || content.length === 0) { continue; }

        var note = document.createElement('div');
        note.className = 'srf-field-note';

        var lbl = document.createElement('div');
        lbl.className = 'srf-field-note__label';

        var body = document.createElement('div');
        body.className = 'srf-field-note__body';
        content.forEach(function(c) { body.appendChild(c); });

        note.appendChild(lbl);
        note.appendChild(body);

        // Insert wrapper while el is still in shell, THEN move el inside
        shell.insertBefore(note, el);
        lbl.appendChild(el);

        changed = true;
        break;
      }
    }
  }

  /* ── Transform bullet lists into editorial visuals ──────── */
  function transformLists() {
    var shell = document.querySelector('.ag-imported-article-shell');
    if (!shell) return;

    var typeMap = {
      'healthier soil': 'benefit-grid',
      'smarter water use': 'water-stat',
      'reduced chemical dependency': 'practice-tags',
      'stronger biodiversity': 'ecosystem-nodes',
      'climate resilience': 'threat-matrix'
    };

    var h3s = Array.from(shell.querySelectorAll(':scope > h3'));
    h3s.forEach(function(h3) {
      var key = h3.textContent.trim().toLowerCase();
      var type = typeMap[key];
      if (!type) return;

      var ul = null;
      var sib = h3.nextElementSibling;
      while (sib) {
        if (sib.tagName === 'UL' && !sib.classList.contains('srf-sources')) { ul = sib; break; }
        if (sib.tagName === 'H3' || sib.tagName === 'H2') break;
        sib = sib.nextElementSibling;
      }
      if (!ul) return;

      var items = Array.from(ul.querySelectorAll('li')).map(function(li) { return li.textContent.trim(); });
      var vis = buildListVis(type, items);
      if (vis) {
        ul.parentNode.insertBefore(vis, ul);
        ul.remove();
      }
    });
  }

  function buildListVis(type, items) {
    var wrap = document.createElement('div');
    wrap.className = 'srf-vis srf-vis--' + type;

    if (type === 'benefit-grid') {
      items.forEach(function(item, i) {
        var card = document.createElement('div');
        card.className = 'srf-benefit-card';
        card.innerHTML = '<span class="srf-bc-num">0' + (i + 1) + '</span>'
          + '<span class="srf-bc-text">' + item + '</span>';
        wrap.appendChild(card);
      });

    } else if (type === 'water-stat') {
      var left = document.createElement('div');
      left.className = 'srf-ws-left';
      left.innerHTML = '<span class="srf-ws-num">30%</span>'
        + '<span class="srf-ws-label">less irrigation\nwater per harvest</span>';
      wrap.appendChild(left);

      var right = document.createElement('div');
      right.className = 'srf-ws-right';
      items.slice(1).forEach(function(item) {
        var row = document.createElement('span');
        row.className = 'srf-ws-row';
        row.textContent = item;
        right.appendChild(row);
      });
      wrap.appendChild(right);

    } else if (type === 'practice-tags') {
      items.forEach(function(item) {
        var tag = document.createElement('span');
        tag.className = 'srf-ptag';
        tag.textContent = item;
        wrap.appendChild(tag);
      });

    } else if (type === 'ecosystem-nodes') {
      items.forEach(function(item) {
        var node = document.createElement('div');
        node.className = 'srf-eco-node';
        node.textContent = item;
        wrap.appendChild(node);
      });

    } else if (type === 'threat-matrix') {
      items.forEach(function(item, i) {
        var row = document.createElement('div');
        row.className = 'srf-threat-row';
        row.innerHTML = '<span class="srf-tr-num">' + String(i + 1).padStart(2, '0') + '</span>'
          + '<span class="srf-tr-text">' + item + '</span>';
        wrap.appendChild(row);
      });
    }

    return wrap;
  }

  /* ── Transform bibliography into org-grouped cards ───────── */
  function transformSources() {
    var shell = document.querySelector('.ag-imported-article-shell');
    if (!shell) return;
    var ul = shell.querySelector(':scope > ul.srf-sources');
    if (!ul) return;

    var orgDefs = [
      { key: 'fao', abbr: 'FAO', full: 'Food & Agriculture Organization', test: function(t) { return /fao|food and agriculture/i.test(t); } },
      { key: 'irri', abbr: 'IRRI', full: "Int'l Rice Research Institute", test: function(t) { return /irri|international rice/i.test(t); } },
      { key: 'ipcc', abbr: 'IPCC', full: 'Intergovernmental Panel on Climate Change', test: function(t) { return /ipcc/i.test(t); } },
      { key: 'unep', abbr: 'UNEP', full: 'UN Environment Programme', test: function(t) { return /unep|nations environment/i.test(t); } },
      { key: 'wb', abbr: 'World Bank', full: 'World Bank Group', test: function(t) { return /world bank/i.test(t); } },
      { key: 'rodale', abbr: 'Rodale', full: 'Rodale Institute', test: function(t) { return /rodale/i.test(t); } }
    ];

    var buckets = {};
    orgDefs.forEach(function(o) { buckets[o.key] = []; });

    Array.from(ul.querySelectorAll('li')).forEach(function(li) {
      var a = li.querySelector('a');
      if (!a) return;
      var text = a.textContent.trim();
      var href = a.getAttribute('href');
      for (var oi = 0; oi < orgDefs.length; oi++) {
        if (orgDefs[oi].test(text)) {
          var display = text
            .replace(/^(Food and Agriculture Organization \(FAO\)|FAO|IRRI|International Rice Research Institute|IPCC|United Nations Environment Programme|UNEP|World Bank)\s*[-–]?\s*/i, '')
            .trim() || text;
          buckets[orgDefs[oi].key].push({ display: display, href: href });
          break;
        }
      }
    });

    var grid = document.createElement('div');
    grid.className = 'srf-sources-grid';

    orgDefs.forEach(function(o) {
      var srcs = buckets[o.key];
      if (!srcs.length) return;
      var card = document.createElement('div');
      card.className = 'srf-source-card';
      card.innerHTML = '<span class="srf-sc-abbr">' + o.abbr + '</span>'
        + '<span class="srf-sc-full">' + o.full + '</span>';
      var links = document.createElement('div');
      links.className = 'srf-sc-links';
      srcs.forEach(function(s) {
        var a = document.createElement('a');
        a.href = s.href;
        a.target = '_blank';
        a.rel = 'noopener';
        a.className = 'srf-sc-link';
        a.textContent = s.display || o.full;
        links.appendChild(a);
      });
      card.appendChild(links);
      grid.appendChild(card);
    });

    ul.parentNode.insertBefore(grid, ul);
    ul.remove();
  }

  /* ── Wrap consecutive h3+p pairs into card grid ──────────── */
  function wrapPillarGroups() {
    var shell = document.querySelector('.ag-imported-article-shell');
    if (!shell) return;

    var changed = true;
    while (changed) {
      changed = false;
      var children = Array.from(shell.children);
      for (var i = 0; i < children.length; i++) {
        if (children[i].tagName !== 'H3') continue;

        var pairs = [];
        var j = i;
        while (j < children.length && children[j].tagName === 'H3') {
          var next = children[j + 1];
          if (next && next.tagName === 'P' && !next.classList.contains('srf-meta')) {
            pairs.push([children[j], next]);
            j += 2;
          } else {
            break;
          }
        }

        if (pairs.length >= 2) {
          var grid = document.createElement('div');
          grid.className = 'srf-pillar-grid';
          shell.insertBefore(grid, pairs[0][0]);
          pairs.forEach(function(pair) {
            var item = document.createElement('div');
            item.className = 'srf-pillar-item';
            item.appendChild(pair[0]);
            item.appendChild(pair[1]);
            grid.appendChild(item);
          });
          changed = true;
          break;
        }
      }
    }
  }

  /* ── Inject featured image as mid-article wide band ─────── */
  function injectImageBreak() {
    var shell = document.querySelector('.ag-imported-article-shell');
    var figure = document.querySelector('.ag-imported-featured-image');
    if (!shell || !figure || shell.querySelector('.srf-image-break')) return;

    var img = figure.querySelector('img');
    if (!img || !img.src) return;

    // Insert after 2nd section divider
    var dividers = shell.querySelectorAll(':scope > .srf-section-divider');
    var anchor = dividers.length >= 2 ? dividers[1] : null;
    if (!anchor) return;

    var band = document.createElement('div');
    band.className = 'srf-image-break';
    var imgDiv = document.createElement('div');
    imgDiv.className = 'srf-image-break__img';
    imgDiv.style.backgroundImage = 'url("' + img.src + '")';
    var cap = document.createElement('p');
    cap.className = 'srf-image-break__caption';
    cap.textContent = 'Fields at Agriko Organic Farm — Mindanao, Philippines';
    band.appendChild(imgDiv);
    band.appendChild(cap);
    shell.insertBefore(band, anchor.nextSibling);
  }

  /* ── Hero background from featured image ─────────────────── */
  function initHeroBg() {
    var hero = document.querySelector('.ag-imported-hero--fallback');
    var figure = document.querySelector('.ag-imported-featured-image');
    if (!hero || !figure) return;

    var img = figure.querySelector('img');
    if (!img) return;

    function applyBg(src) {
      hero.style.backgroundImage = 'url("' + src + '")';
    }

    if (img.complete && img.naturalWidth > 0) {
      applyBg(img.src);
    } else {
      img.addEventListener('load', function () { applyBg(img.src); });
      // Also try srcset largest size for quality
      if (img.src) applyBg(img.src);
    }
  }

  /* ── Mark elements for scroll reveal ─────────────────────── */
  function markRevealElements() {
    var shell = document.querySelector('.ag-imported-article-shell');
    if (!shell) return;
    ['.srf-pull-quote', '.srf-vis', '.srf-pillar-item',
     '.srf-image-break', '.srf-field-note', '.srf-section-deck',
     '.srf-closing-mark'].forEach(function(sel) {
      shell.querySelectorAll(sel).forEach(function(el) {
        el.classList.add('srf-reveal');
      });
    });
  }

  /* ── Inject closing ceremony mark before Sources h2 ──────── */
  function injectClosingMark() {
    var shell = document.querySelector('.ag-imported-article-shell');
    if (!shell || shell.querySelector('.srf-closing-mark')) return;
    var sources = shell.querySelector('h2.srf-sources');
    if (!sources) return;
    var mark = document.createElement('div');
    mark.className = 'srf-closing-mark';
    mark.innerHTML = '<span class="srf-cm-rule"></span>'
      + '<span class="srf-cm-icon">✦</span>'
      + '<span class="srf-cm-rule"></span>';
    sources.parentNode.insertBefore(mark, sources);
  }

  /* ── Init on DOM ready ────────────────────────────────────── */
  function init() {
    initProgressBar();
    labelSpecialElements();
    wrapPillarGroups();
    transformLists();
    transformSources();
    injectImageBreak();
    initHeroBg();
    injectClosingMark();
    markRevealElements();
    initScrollReveal();
    // Counters may need JS-rendered article content — poll briefly
    var attempts = 0;
    function tryCounters() {
      if (document.querySelector('.ag-imported-stats--detail')) {
        initCounters();
      } else if (attempts < 20) {
        attempts++;
        setTimeout(tryCounters, 300);
      }
    }
    tryCounters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
